/**
 * Classifies an uploaded file so callers can route videos through the
 * Mux pipeline and everything else (images, PDFs, CAD drawings, text, etc.)
 * through the regular attachment upload.
 *
 * Browsers report `file.type` as an empty string for extensions they don't
 * recognise (e.g. .dxf, .ipt, .step). Those must still count as documents.
 */
export type FileKind = 'video' | 'document';

export function classifyFile(file: File): FileKind {
  return file.type?.startsWith('video/') ? 'video' : 'document';
}
